"use client";

import { useEffect, useState, useRef } from "react";
import { usePathname } from "next/navigation";
import { Footer } from "@/components/Footer";
import { CookieConsent } from "@/components/CookieConsent";
import { UsernameGate } from "@/components/UsernameGate";
import { PhoneVerificationGate } from "@/components/PhoneVerificationGate";
import {
  PACK_OPENING_CHROME_EVENT,
  type PackOpeningChromeDetail,
} from "@/components/opening/pack-opening-chrome";

function RouteMainFocus() {
  const pathname = usePathname();
  const isFirst = useRef(true);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    const main = document.getElementById("main-content");
    if (main) main.focus();
  }, [pathname]);

  return null;
}

export function WebChrome({ children }: { children: React.ReactNode }) {
  const [distractionFree, setDistractionFree] = useState(false);

  useEffect(() => {
    function onChrome(e: Event) {
      const ce = e as CustomEvent<PackOpeningChromeDetail>;
      setDistractionFree(!!ce.detail?.distractionFree);
    }
    window.addEventListener(PACK_OPENING_CHROME_EVENT, onChrome);
    return () => window.removeEventListener(PACK_OPENING_CHROME_EVENT, onChrome);
  }, []);

  const showFooter = !distractionFree;

  return (
    <>
      <RouteMainFocus />
      {children}
      {showFooter && <Footer />}
      <CookieConsent />
      <UsernameGate />
      <PhoneVerificationGate />
    </>
  );
}
